import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_PATH } from "../../environment";

const EMPLOYEE_API_URL = `${API_BASE_PATH}/register/admin/register`;

const extractErrorMessage = (error: any) => {
  const detail = error?.response?.data?.detail;
  let details = error?.response?.data?.details;
  const message = error?.response?.data?.message;

  if (typeof details === "string") {
    details = details.replace(/^\d+\s*:\s*/, ""); // strip numeric codes
  }

  return detail || details || message;
};

const useCreateEmployee = () => {
  const [isLoading, setIsLoading] = useState(false);

  const createEmployee = async (formData: FormData, onSuccess?: () => void, _token?: string | null) => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.post(EMPLOYEE_API_URL, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success("Employee added successfully!");
      if (onSuccess) {
        onSuccess();
      }
      return response.data;
    } catch (error: any) {
      const message = extractErrorMessage(error);
      toast.error(message);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    createEmployee,
    isLoading,
  };
};

export default useCreateEmployee;
